import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';
import api from '../services/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, setIsAuthenticated } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL hash
        const hash = location.hash;
        const sessionMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionMatch) {
          console.error('No session_id found in URL');
          navigate('/signin', { replace: true });
          return;
        }

        const sessionId = sessionMatch[1];

        // Exchange session_id for user data
        const response = await api.get('/auth/oauth/session', {
          params: { session_id: sessionId }
        });

        if (response.data.user) {
          // Store session token in localStorage as backup
          if (response.data.session_token) {
            localStorage.setItem('session_token', response.data.session_token);
            console.log('Session token stored:', response.data.session_token.substring(0, 20) + '...');
          } else {
            console.warn('No session_token in response:', response.data);
          }
          setUser(response.data.user);
          setIsAuthenticated(true);
          navigate('/', { replace: true, state: { user: response.data.user } });
        } else {
          throw new Error('No user data received');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/signin', { replace: true });
      }
    };

    processSession();
  }, [location, navigate, setUser, setIsAuthenticated]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 text-electric animate-spin mx-auto mb-4" />
        <p className="text-foreground/70">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
